import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import {DynamicComponent} from 'go/components/dynamic/dynamicComponent';
import {DynamicMultiSelectField} from './DynamicMultiSelectField';
import React from 'react';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class DynamicMultiSelectFieldApiSearch extends DynamicComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  performSearch = async (value) => {
    if (value.length < 2) {
      this.setState({
        results: [],
      });
      return;
    }

    const {
      apiService,
      apiAction,
      optKey,
      optVal,
      optText,
      additionalParamKey,
      additionalParamValue,
      excludedOptVals,
      contextPathToSave,
    } = this.props;
    if (apiService && apiAction) {
      let searchValue = value;
      if (additionalParamKey && additionalParamValue) {
        searchValue = {value, [additionalParamKey]: additionalParamValue};
      }
      return await REST[apiService][apiAction](searchValue)
        .then((res) => forceJsonResponse(res, FLUX))
        .then((res) => {
          if (res && excludedOptVals) {
            res = res.filter((item) => !excludedOptVals.includes(item[optKey]));
          }
          if (res) {
            if (contextPathToSave) {
              this.props.saveEntitySessionData(contextPathToSave, res);
            }
            const options = res.map((item) => {
              return {
                key: optKey ? item[optKey] : item,
                value: optVal ? item[optVal] : item,
                text: optText ? item[optText] : item,
              };
            });
            this.setState({
              results: options,
            });
          }
        })
        .catch((error) => console.log(error));
    } else {
      return;
    }
  };

  handleSearchChange = (e, data) => {
    let value = data.searchQuery;
    this.setState({isLoading: true, value});
    setTimeout(async () => {
      await this.performSearch(value);
      this.setState({
        isLoading: false,
      });
    }, 300);
  };

  render = () => {
    const {
      guidance,
      title,
      optional,
      pathToBeUsed,
      isHidden,
      formOptions,
      size,
      disabled,
      validationErrors,
      validationDirtyMap,
      validationId,
      id,
      ariaLabelledBy,
      search,
      multiple,
      readOnly,
      saveData,
      saveEntityData,
      clearEntityData,
      entityDataPath,
      entityType,
      dynamicComponent,
      keepPreviousOptions,
      value,
      pathForObjectRef,
      data,
      childProps,
      placeholder,
    } = this.props;

    const {results, isLoading} = this.state;

    return (
      <React.Fragment>
        <DynamicMultiSelectField
          onSearchChange={_.debounce(this.handleSearchChange, 1500)}
          multiple={multiple}
          search={search}
          label={title}
          options={results ? results : []}
          size={size}
          name={pathToBeUsed}
          guidance={guidance}
          formOptions={formOptions}
          disabled={disabled}
          optional={optional}
          id={id || pathToBeUsed}
          aria-labelledby={ariaLabelledBy || id}
          readOnly={readOnly}
          saveData={saveData}
          saveEntityData={saveEntityData}
          clearEntityData={clearEntityData}
          entityDataPath={entityDataPath}
          entityType={entityType}
          validationErrors={validationErrors}
          validationDirtyMap={validationDirtyMap}
          validationId={validationId}
          pathToBeUsed={pathToBeUsed}
          isHidden={isHidden}
          dynamicComponent={dynamicComponent}
          loading={isLoading}
          keepPreviousOptions={keepPreviousOptions}
          value={value || data}
          pathForObjectRef={pathForObjectRef}
          // Instead of copying the logic from the inner multiselect to generate the initial options,
          // give us a way to pass in the dependencies it uses to generate them
          dependencies={childProps?.dependencies}
          arrayKey={childProps?.arrayKey}
          arrayValue={childProps?.arrayValue}
          arrayText={childProps?.arrayText}
          placeholder={placeholder}
        />
      </React.Fragment>
    );
  };
}

export const mapStateToProps = (state, props) => {
  const excludedOptPath = _.get(props, 'excludedOptPath', '');
  const excludedPaths = excludedOptPath.split(/\s*,\s*/);
  const excludedOptVals = excludedPaths.reduce(
    (acc, path) => acc.concat(_.get(state.dynamicComponent, path, [])),
    []
  );

  return {
    dynamicComponent: state.dynamicComponent,
    excludedOptVals,
  };
};

export default connect(
  mapStateToProps,
  null
)(connectWithCore(DynamicMultiSelectFieldApiSearch));
